import { render } from "./MfittSelectCoupon.vue?vue&type=template&id=28661ece"
import script from "./MfittSelectCoupon.vue?vue&type=script&lang=js"
export * from "./MfittSelectCoupon.vue?vue&type=script&lang=js"
script.render = render

export default script